/*
 * @Author: Dom
 * @Date: 2022-05-13 09:27:30
 * @LastEditTime: 2022-05-20 15:24:13
 * @LastEditors: Dom
 * @FilePath: \seller-web\src\views\user\login\service.ts
 */
import request from '@/utils/request';
import { LoginParamsType, AreaParams } from './data.d';

export async function accountLogin(params: LoginParamsType): Promise<any> {
    ///user/login
    return request({
        url: '/seller/v1/login/userLogin',
        method: 'POST',
        data: params,
    });
}

export async function getArea(): Promise<any> {
    return request({
      url: '/seller/v1/area/getAreaEnumerate',
      method: 'get',
    });
}

export async function pickupScope() {
  return request({
      url: '/seller/v1/homePage/pickupScope',
      method: 'POST',
  })
}

export async function getArea4PickupList(params:AreaParams): Promise<any>{
  return request({
      url: '/seller/v1/area/getArea4PickupList',
      method: 'GET',
      params
  })
}

export async function getStationAreaList(params:AreaParams): Promise<any>{
  return request({
      url: '/seller/v1/area/getStationAreaList',
      method: 'GET',
      params
  })
}

